module.exports = __webpack_public_path__ + "img/ico-like01.e2d04bc1.svg";